import ResumeSection from "../components/portfolio/ResumeSection";

const ResumePage = () => {
  return <ResumeSection />;
};

export default ResumePage;
